<template>
  <div :class="checkWidth() + ' ' + 'container'">
    <template v-if="loading">
      <div class="container vertical-center">
        <LoadingMDL />
      </div>
    </template>
    <template v-else>
      <CRow>
        <CCol col="12">
          <CardImageSquare :cardContent="content" @nextRoute="nextRoute" />
        </CCol>
      </CRow>
    </template>
  </div>
</template>

<script>
import CardImageSquare from "../../components/template/Chinese1/CardImageSquare";
import { mapGetters } from "vuex";
import "../../assets/scss/_chineseStyle.scss";
import "../../assets/scss/_chineseModalCustom.scss";
import LoadingMDL from "../../components/loading/LoadingMDL";

export default {
  components: { CardImageSquare, LoadingMDL },
  name: "CTT04",
  data() {
    return {
      content: {},
      widthScreen: window.innerWidth,
      lang: this.$store.getters["language/getLanguage"],
      baseUrl: process.env.VUE_APP_URL_SOUND,
      pageCode: "",
      CheckWidth: window.innerWidth.toString(),
      loaded: false,
      userTemplateData: [],
      nextAction: [],
      courseSection: "",
      startTime: "",
      condition: [],
      loading: true,
    };
  },

  computed: {
    ...mapGetters({
      allCourse: "template/getTemplateContent",
      getUserTemplate: "template/getUserTemplate",
      loadingGetter: "template/loadingGetter",
    }),
  },

  watch: {
    allCourse: function (val) {
      if (!val.enable) {
        alert("Access denied!");
        this.$router.push({ name: val.navigate.close.action });
      } else {
        this.content = val;
        this.courseSection = this.$store.getters['necessary/getUserCourseSection']
        this.$store.dispatch("template/createUserTemplateData", {
          code: this.courseCode,
          template: val._id,
          section: this.courseSection,
        });
      }
    },
    getUserTemplate: function (val) {
      this.userTemplateData = val;
      this.condition = [
        {
          criteria: val.data.condition.criteriaType[0].criteria._id,
          val: val.data.condition.criteriaType[0].val,
        },
      ];
      this.loading = false
    },
    loadingGetter: function (val) {
      if (val == true) {
        this.$router.push(this.nextAction);
      }
    },
  },

  mounted() {
    let body = {};
    body.code = this.courseCode;
    body.templateCode = `CTT04-` + this.$route.params.id;
    this.$store.dispatch("template/fetchContent", body);
  },

  created() {
    this.courseCode = this.$store.getters["necessary/getLerningCourse"]._id;
    this.lang = this.$store.state.language.language;
    this.startTime = this.$helpers.getDateFormat();
  },

  beforeDestroy() {},
  methods: {
    checkWidth() {
      if (this.CheckWidth > 800) {
        return "container-chinese-card";
      } else if (this.CheckWidth <= 800) {
        return "container-chinese-card-mobile";
      }
      // return "container-chinese-card-mobile"
    },
    checkLangClass() {
      if (this.lang == "CN") {
        return "fontChinese";
      } else if (this.lang == "PIN IN") {
        return "fontPinin";
      } else {
        return "";
      }
    },
    nextRoute(path) {
      let str = path.split("-");
      this.funcRoute(str);
    },
    funcRoute(val) {
      const useTime = this.$helpers.getUseTime();

      if (typeof val === "string") {
        this.nextAction = this.$helpers.setChineseUrl(val);
      } else {
        this.$store.commit("necessary/setCodePage", val[1]);
        this.nextAction = "/" + val[0] + "/" + val[1];
      }
      /*
      this.$store.dispatch(
        "template/saveUserTemplateData",
        this.userTemplateData
      );
      */
      this.$store.dispatch("template/saveUserTemplateData", {
        code: this.courseCode,
        template: this.content._id,
        section: this.courseSection,
        answering: [],
        startTime: this.startTime,
        endTime: this.$helpers.getDateFormat(),
        condition: this.condition,
      });
    },
  },
};
</script>
<style>
</style>